<div [class.input-group]="suffix">
    <label *ngIf="label" class="control-label">{{ label }}</label>
    <input
        [class.form-control]="type !== 'checkbox'"
        autocomplete="off"
        [formControl]="control"
        [type]="type"
        (blur)="blurEventHandler()"
    />

    <div class="input-group-addon" *ngIf="suffix">
        {{ suffix }}
    </div>

    <small class="form-text text-muted" *ngIf="!!hint">{{ hint }}</small>
</div>
